/**
 * Address Types
 *
 * Type definitions for address-related data structures used
 * throughout the address autocomplete and form components.
 */

/**
 * Parsed address components from Google Places
 */
export interface AddressComponents {
  street: string;
  exterior_number: string;
  interior_number: string;
  neighborhood: string; // colonia
  city: string;
  municipality: string;
  state: string;
  zip_code: string;
  country: string;
  formatted_address: string;
}

/**
 * Google Places prediction result
 */
export interface PlacePrediction {
  place_id: string;
  description: string;
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
}

/**
 * Address form data structure (unified across components)
 */
export interface AddressFormData {
  street: string;
  exterior_number: string;
  interior_number: string;
  neighborhood: string;
  city: string;
  municipality: string;
  state: string;
  zip_code: string;
}

/**
 * Create an empty AddressFormData object
 */
export const createEmptyAddressFormData = (): AddressFormData => ({
  street: "",
  exterior_number: "",
  interior_number: "",
  neighborhood: "",
  city: "",
  municipality: "",
  state: "",
  zip_code: "",
});

/**
 * Create an empty AddressComponents object
 */
export const createEmptyAddressComponents = (): AddressComponents => ({
  street: "",
  exterior_number: "",
  interior_number: "",
  neighborhood: "",
  city: "",
  municipality: "",
  state: "",
  zip_code: "",
  country: "",
  formatted_address: "",
});
